import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoBlockComponent, InfoBlockData } from './info-block.component';
import { SERVER_BASE_URL } from '../environment.token';
import { InfoBlock } from 'apps/design4circularity/src/app/models';

@Component({
  selector: 'ca-coloured-block-list',
  imports: [CommonModule, InfoBlockComponent],
  template: `
  @if (data){
    <div
    [class]="rootClass">
      <div class="block-list-header">
        <h2>{{ data.intro.title }}</h2>
        <h3>{{ data.intro.subtitle }}</h3>
        <div [innerHTML]="data.intro.richText"></div>
      </div>

      @for (item of data.content; track $index) {
        <ca-info-block [data]="item" [hideImage]="true">
          <ng-container ngProjectAs="list-decorator">
            @switch (data.mode) {
              @case ('numbered') {
                <div class="block-list-number"><span>{{ $index+1 }}</span></div>
              }
              @case ('do-dont') {
                @if (isDoDont(item.content)) {
                  @if (item.content.do) {
                    <div class="do"><span class="material-symbols-outlined">verified</span></div>
                  } @else {
                    <div class="dont"><span class="material-symbols-outlined">block</span></div>
                  }
                }
              }

              @case ('thumbnail') {
                @if (isThumbnail(item.content)) {
                  <img
                      [src]="base + item.content.image.src"
                      [alt]="item.content.image.alt" />
                }
              }

            }
          </ng-container>
        </ca-info-block>
      }
    </div>
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColouredBlockListComponent {
  @Input() data?: ColouredBlockListData;
  get rootClass() {
    let c = 'coloured-block-list';
    if (this.data) {
      if (this.data.color)
        c += ` ${this.data.color}`;
      if (this.data.mode)
        c += ` ${this.data.mode}`;
      if (this.data.mode === 'thumbnail' && this.data.alternateThumbPositions)
        c += ' alternating-thumb-positions';
      if (this.data.cssClass)
        c += ` ${this.data.cssClass}`;
      console.log(this.data, c);
      return c;
    }
    else return 'coloured-block-list';
  }
  readonly base = inject(SERVER_BASE_URL);

  isDoDont(item: any): item is { do: boolean } {
    return 'do' in item;
  }

  isThumbnail(item: any): item is ThumbnailBlockListData['content'][number] {
    return 'image' in item;
  }
}

export type ColouredBlockListData = {
  color: 'primary' | 'secondary';
  intro: InfoBlockData['content'];
  cssClass: string | null;
} & (NumberedBlockListData | DoDontBlockListData | ThumbnailBlockListData);

export type NumberedBlockListData = {
  mode: 'numbered';
  content: Omit<InfoBlock, 'type'>[];
};

export type DoDontBlockListData = {
  mode: 'do-dont';
  content: (Omit<InfoBlock, 'type'> & { do: boolean })[];
};

export type ThumbnailBlockListData = {
  mode: 'thumbnail';
  alternateThumbPositions: boolean;
  cssClass: null | string;
  content: (Omit<InfoBlock, 'type'> & {
    image: { src: string; alt: string };
  })[];
};
